


















































































































import { format, parseISO } from "date-fns";
import VueI18n from "vue-i18n";
import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  TreatmentDatabasesApi,
  FailureTrackingsApiGetFailureTrackingsByKeywordRequest,
  FailureTrackingsApiExportFailureTrackingRequest,
  TreatmentMasterListsApi,
  FailureTrackingsApi,
  TreatmentRequestsApiGetTreatmentRequestsByKeywordRequest,
  TreatmentRequestsApiExportTreatmentRequestsByKeywordRequest,
} from "../../../apis";
import ConfirmDialog from "../../components/user-management/ConfirmDialog.vue";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import moment from "moment";
import { VueExcelEco2 } from "../common/VueExcelEco2";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";

export enum ACTION {
  VIEW = "VIEW",
  EDIT = "EDIT",
  CLOSE = "CLOSE",
  DELETE = "DELETE",
}

@Component({
  components: {
    MoreVertBtn,
    ConfirmDialog,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class FailureTrackingList extends Vue {
  items: any[] = [];
  pagingOption: DataOptions | null = null;
  searchParam: any = {
    status: "",
  };
  totalRecord: number = 0;
  pageBeforeSort: number = 0;

  statusOptions = [
    {
      name: this.$t("text.all"),
      value: "",
    },
    {
      name: this.$t("text.Closed"),
      value: "Closed",
    },
    {
      name: this.$t("text.Open"),
      value: "Open",
    },
  ];

  isShowContinueTreatmentDialog = false;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  columnsExport = [
    {
      label: this.$t("text.customer"),
      field: "customer.companyName",
    },
    {
      label: this.$t("text.location"),
      field: "location.locationName",
    },
    {
      label: this.$t("locationColumn.unit"),
      field: "unit.name",
    },
    {
      label: this.$t("text.dateOpen"),
      field: "dateOpen",
    },
    {
      label: this.$t("text.lastChangedBy"),
      field: "updatedBy.fullName",
    },
    {
      label: this.$t("text.status"),
      field: "status",
    },
    {
      label: this.$t("text.dateClosed"),
      field: "dateClosed",
    },
    {
      label: this.$t("text.failureName"),
      field: "failureName",
    },
    {
      label: this.$t("text.describe"),
      field: "describe",
    },
    {
      label: this.$t("text.causeOfFailure"),
      field: "causeOfFailure",
    },
    {
      label: this.$t("text.solution"),
      field: "solution",
    },
    {
      label: this.$t("text.remark"),
      field: "remark",
    },
  ];

  dataExport = [];
  readonly VIEW_ACTION: IAction = {
    titleName: this.$t("text.view"),
    action: ACTION.VIEW,
    permission: { context: "FAILURE_TRACKING_MANAGEMENT", action: "read" },
  };

  readonly EDIT_ACTION: IAction = {
    titleName: this.$t("text.edit"),
    action: ACTION.EDIT,
    permission: { context: "FAILURE_TRACKING_MANAGEMENT", action: "update" },
  };

  readonly CLOSE_ACTION: IAction = {
    titleName: this.$t("text.close"),
    action: ACTION.CLOSE,
    titleStyle: "color: #E54949",
    permission: { context: "FAILURE_TRACKING_MANAGEMENT", action: "delete" },
  };

  readonly DELETE_ACTION: IAction = {
    titleName: this.$t("text.delete"),
    action: ACTION.DELETE,
    titleStyle: "color: #E54949",
    permission: { context: "FAILURE_TRACKING_MANAGEMENT", action: "delete" },
  };

  actions: Array<IAction> = [
    { titleName: this.$t("text.view"), action: ACTION.VIEW },
    { titleName: this.$t("text.edit"), action: ACTION.EDIT },
    {
      titleName: this.$t("text.continue"),
      action: ACTION.CLOSE,
      titleStyle: "color: #43D79E",
    },
    {
      titleName: this.$t("text.delete"),
      action: ACTION.DELETE,
      titleStyle: "color: #E54949",
    },
  ];

  BASE_HEADER = [
    {
      text: this.$t("text.customer"),
      value: "customer.companyName",
    },
    {
      text: this.$t("text.location"),
      value: "location.locationName",
    },
    {
      text: this.$t("locationColumn.unit"),
      value: "unit.name",
    },
    {
      text: this.$t("text.dateOpen"),
      value: "dateOpen",
    },
    {
      text: this.$t("text.lastChangedBy"),
      value: "updatedBy.fullName",
    },
    {
      text: this.$t("text.status"),
      value: "status",
    },
    {
      text: this.$t("text.dateClosed"),
      value: "dateClosed",
    },
    {
      text: this.$t("text.failureName"),
      value: "failureName",
    },
    {
      text: this.$t("text.describe"),
      value: "describe",
    },
    {
      text: this.$t("text.causeOfFailure"),
      value: "causeOfFailure",
    },
    {
      text: this.$t("text.solution"),
      value: "solution",
    },
    {
      text: this.$t("text.remark"),
      value: "remark",
    },
    { text: this.$t("text.action"), value: "action", sortable: false },
  ] as DataTableHeader[];

  headers = this.BASE_HEADER as DataTableHeader[];

  confirmContent: string | VueI18n.TranslateResult = "";
  showConfirmDialog = false;

  createdFromDate = new Date().toISOString().substr(0, 10);
  createddateClosed = new Date().toISOString().substr(0, 10);

  async mounted() {}

  async onSearch() {
    await this.doSearch();
  }

  onPagingOption() {
    this.onSearch();
  }

  getActionByStatus(status: string): Array<IAction> {
    switch (status) {
      case "Open": {
        return [
          this.VIEW_ACTION,
          this.EDIT_ACTION,
          this.CLOSE_ACTION,
          this.DELETE_ACTION,
        ];
      }
      case "Closed": {
        return [this.VIEW_ACTION, this.EDIT_ACTION, this.DELETE_ACTION];
      }
      default: {
        return [this.DELETE_ACTION];
      }
    }
  }

  async doSearch(): Promise<void> {
    try {
      this.$util.showLoading();
      await this.handleFilter();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async handleFilter() {
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };

    const openDate = this.searchParam.openDate
      ? moment(this.searchParam.openDate, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const closedDate = this.searchParam.closedDate
      ? moment(this.searchParam.closedDate, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;

    const body = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      status: getValueOrUndefined(this.searchParam.status),
      openDate: openDate,
      closedDate: closedDate,
      limit: this.pagingOption.itemsPerPage,
      page: this.pagingOption.page,
      orderBy: getValueOrUndefined(this.pagingOption.sortBy[0]),
      orderDesc: getValueOrUndefined(this.pagingOption.sortDesc[0]),
    } as FailureTrackingsApiGetFailureTrackingsByKeywordRequest;
    try {
      const res = await new FailureTrackingsApi().getFailureTrackingsByKeyword(
        body
      );
      this.totalRecord = res.data.count;
      this.items = res.data.data.map((failureTracking) => {
        return { ...failureTracking, remark: failureTracking.remark || "-" };
      });
    } catch (error) {
      this.$util.showError(error);
    }
  }

  selectedFailureTracking;
  selectedAction: ACTION;
  onSelectedTreatment({ item, action }): void {
    this.selectedFailureTracking = { ...item };
    this.selectedAction = action;
    switch (action) {
      case ACTION.VIEW: {
        this.onViewFailureTracking();
        break;
      }
      case ACTION.EDIT: {
        this.onEditFailureTracking();
        break;
      }
      case ACTION.CLOSE: {
        this.onCloseFailureTracking();
        break;
      }
      case ACTION.DELETE: {
        this.onDeleteFailureTracking();
        break;
      }
      default: {
        console.error(action);
        break;
      }
    }
  }

  onViewFailureTracking() {
    return this.$router.push({
      name: "view-failure-tracking",
      params: { id: this.selectedFailureTracking.id },
      query: { status: this.selectedFailureTracking.status },
    });
  }

  onEditFailureTracking() {
    return this.$router.push({
      name: "edit-failure-tracking",
      params: { id: this.selectedFailureTracking.id },
    });
  }

  onCloseFailureTracking() {
    this.showConfirmDialog = true;
    this.confirmContent = this.$t("dialog.close.failureTracking");
  }

  async doCloseFailureTracking() {
    this.$util.showLoading();
    try {
      await new FailureTrackingsApi().closeFailureTracking({
        id: this.selectedFailureTracking.id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
    this.doSearch();
  }

  onDeleteFailureTracking() {
    this.showConfirmDialog = true;
    this.confirmContent = this.$t("dialog.delete.failureTracking");
  }

  onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE) {
      this.doDelete();
    }
    if (this.selectedAction === ACTION.CLOSE) {
      this.doCloseFailureTracking();
    }
  }

  onContinueTreatmentRequest() {
    this.isShowContinueTreatmentDialog = true;
  }

  async continuedTreatmentRequest() {
    this.isShowContinueTreatmentDialog = false;
    this.doSearch();
  }

  async doDelete() {
    this.$util.showLoading();
    try {
      await new FailureTrackingsApi().deleteFailureTracking({
        id: this.selectedFailureTracking.id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
    this.doSearch();
  }

  get exportClick() {
    return this.$store.getters.export;
  }

  @Watch("exportClick")
  onExportClick() {
    this.doExport();
  }

  async doExport() {
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };
    const openDate = this.searchParam.openDate
      ? moment(this.searchParam.openDate, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const closedDate = this.searchParam.closedDate
      ? moment(this.searchParam.closedDate, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;

    const body = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      status: getValueOrUndefined(this.searchParam.status),
      openDate: openDate,
      closedDate: closedDate,
    } as FailureTrackingsApiExportFailureTrackingRequest;
    try {
      const res = await new FailureTrackingsApi().exportFailureTracking(body);
      this.dataExport = res.data.data.map((failure) => {
        return {
          ...failure,
          dateOpen: failure.dateOpen ? moment(failure.dateOpen).format("DD/MM/YYYY") : '',
          dateClosed: failure.dateClosed ? moment(failure.dateClosed).format("DD/MM/YYYY") : '',
          status: this.$t(`text.${failure.status}`),
        };
      });
    } catch (error) {
      this.$util.showError(error);
      throw new Error("getFailureTrackingsByKeyword Failed");
    } finally {
      const data = this.lodash.reverse(this.dataExport);
      const exportExcel = new VueExcelEco2(
        "ECO2 - Export Failure Tracking",
        "xlsx",
        "ECO2 Web",
        data,
        this.columnsExport
      ).exportExcel();
      this.$util.hideLoading();
    }
  }
}
